import { useEffect } from "react";
import { useParams } from "react-router-dom";
import Data from '../data/Data';
import Header from './Header';

function AccountVerification() {
  const { token } = useParams();

  useEffect(() => {
    async function fetchVerification() {
      try {
        await Data.fetchVerification(token);
      } catch (ex) {}
      window.location = '/login';
    }

    fetchVerification();
  }, [token]);


  return (
    <div>
      <Header background />
      <div className='AccountVerification container'>
        <h1>Welcome!</h1>
        <h2>We are verificating your user...</h2>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  )
}

export default AccountVerification;